
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';

export default function Gallery() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const galleryJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'MenuSection',
    name: 'Lemonade Coffee Store – Menu',
    description: 'View our full menu of signature lemonade and Malfi Coffee drinks including Honey Lemonade Coffee, Salted Caramel Latte, and Coffee Lemonade fusion beverages.',
    url: `${siteUrl}/gallery`,
    hasMenuSection: {
      '@type': 'MenuSection',
      name: 'Signature Drinks',
      description: 'Our handcrafted lemonade and coffee fusion beverages',
    },
  };

  return (
    <div className="min-h-screen bg-[#FFF8E7] flex flex-col">
      <SeoHead
        title="Menu – Lemonade Coffee Store | Honey Lemonade Coffee &amp; Malfi Coffee Drinks"
        description="Browse the Lemonade Coffee Store menu. Discover our signature Honey Lemonade Coffee, Salted Caramel Latte, Coffee Lemonade fusion, and more refreshing drinks in Orange County, CA."
        keywords="lemonade coffee menu, honey lemonade coffee, Malfi Coffee drinks, coffee lemonade menu Orange County"
        canonical={`${siteUrl}/gallery`}
        jsonLd={galleryJsonLd}
      />
      <Navbar />

      <main className="flex-1 flex flex-col items-center justify-center text-center px-4 py-32">
        <div className="w-20 h-20 flex items-center justify-center mb-8 rounded-full bg-[#FFD700]/20">
          <i className="ri-tools-line text-4xl text-[#2C5F2D]"></i>
        </div>
        <h1 className="text-5xl font-bold text-[#2C5F2D] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
          Coming Soon
        </h1>
        <p className="text-lg text-[#666] max-w-md leading-relaxed">
          We're working on something great. This page is currently under construction — check back soon!
        </p>
      </main>

      <Footer />
    </div>
  );
}
